export enum Theme {
  THEME_LIGHT_BLACK_PURPLE = 'theme-light-black-purple',
  THEME_LIGHT_BLUE = 'theme-light-blue',
  THEME_LIGHT_HTS = 'theme-light-hts',
}
